import React, { Fragment } from 'react';
import logo from '../../assets/images/alphareview_logo.png';
import { Container } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<Fragment>
			<footer className='bg-slate-950 text-slate-400 pt-16 pb-12 border-t border-slate-800'>
				<Container maxWidth='lg'>
					<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12'>
						{/* Company Info & Local Authority (GEO / Local SEO) */}
						<div className='lg:col-span-2 space-y-4'>
							<Link to='/' className='inline-block bg-white px-3.5 py-1.5 rounded-xl shadow-sm'>
								<img
									src={logo}
									alt='AlphaReview Logo'
									style={{ height: '36px', objectFit: 'contain' }}
								/>
							</Link>
							<p className='text-sm text-slate-400 leading-relaxed max-w-sm'>
								India’s #1 Smart Contactless NFC & Dynamic QR Customer Review Card platform. Empowering local businesses to scale 5-star Google Reviews with AI assistance and automated negative review filtering.
							</p>
							<div className='text-xs text-slate-500 space-y-1 pt-1'>
								<p>📍 Headquartered in Bangalore, Karnataka, India</p>
								<p>🚚 Pan-India Express Delivery via Bluedart, Delhivery & DTDC</p>
							</div>
							<div className='flex items-center space-x-3 pt-2'>
								<a
									href='https://wa.me/919880889303'
									target='_blank'
									rel='noopener noreferrer'
									className='w-9 h-9 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center text-emerald-400 hover:text-white hover:bg-emerald-600 transition-colors'
									aria-label='WhatsApp'>
									<i className='fa fa-whatsapp'></i>
								</a>
								<a
									href='mailto:hello@alphareview.in'
									className='w-9 h-9 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center text-blue-400 hover:text-white hover:bg-blue-600 transition-colors'
									aria-label='Email'>
									<i className='fa fa-envelope'></i>
								</a>
								<a
									href='https://alphareview.in/'
									className='w-9 h-9 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-300 hover:text-white hover:bg-slate-800 transition-colors'
									aria-label='Website'>
									<i className='fa fa-globe'></i>
								</a>
							</div>
						</div>

						{/* Product Links */}
						<div>
							<h4 className='text-xs font-bold uppercase tracking-wider text-white mb-4'>Product</h4>
							<ul className='space-y-2.5 text-sm'>
								<li>
									<Link to='/' className='hover:text-white transition-colors'>
										Home
									</Link>
								</li>
								<li>
									<Link to='/pricing' className='hover:text-white transition-colors'>
										Smart NFC Cards
									</Link>
								</li>
								<li>
									<a
										href='/review/40/Alpha+Connects'
										target='_blank'
										rel='noopener noreferrer'
										className='text-blue-400 font-semibold hover:text-blue-300 transition-colors flex items-center gap-1.5'>
										<span>Live 5★ Demo</span>
										<span className='px-1 py-0.2 text-[10px] bg-blue-900 text-blue-200 rounded'>
											Try
										</span>
									</a>
								</li>
								<li>
									<Link to='/pricing' className='hover:text-white transition-colors'>
										Bulk Standees
									</Link>
								</li>
								<li>
									<a href='#how-it-works' className='hover:text-white transition-colors'>
										How It Works
									</a>
								</li>
							</ul>
						</div>

						{/* Portals & Solutions */}
						<div>
							<h4 className='text-xs font-bold uppercase tracking-wider text-white mb-4'>Business Portals</h4>
							<ul className='space-y-2.5 text-sm'>
								<li>
									<a href='/user' className='hover:text-white transition-colors'>
										Business Login
									</a>
								</li>
								<li>
									<Link to='/signup' className='hover:text-white transition-colors'>
										Register Business
									</Link>
								</li>
								<li>
									<a href='#calculator' className='hover:text-white transition-colors'>
										ROI Calculator
									</a>
								</li>
								<li>
									<a href='https://wa.me/919880889303' target='_blank' rel='noopener noreferrer' className='text-emerald-400 hover:text-emerald-300 transition-colors'>
										Agency Whitelabel
									</a>
								</li>
							</ul>
						</div>

						{/* Support & Legal */}
						<div>
							<h4 className='text-xs font-bold uppercase tracking-wider text-white mb-4'>Help & Legal</h4>
							<ul className='space-y-2.5 text-sm'>
								<li>
									<a
										href='https://wa.me/919880889303'
										target='_blank'
										rel='noopener noreferrer'
										className='hover:text-white transition-colors'>
										WhatsApp: +91 98808 89303
									</a>
								</li>
								<li>
									<a href='mailto:hello@alphareview.in' className='hover:text-white transition-colors'>
										Email: hello@alphareview.in
									</a>
								</li>
								<li>
									<a href='#faq' className='hover:text-white transition-colors'>
										FAQ Section
									</a>
								</li>
								<li>
									<Link to='/privacypolicy' className='hover:text-white transition-colors'>
										Privacy Policy
									</Link>
								</li>
								<li>
									<Link to='/termcondition' className='hover:text-white transition-colors'>
										Terms of Service
									</Link>
								</li>
							</ul>
						</div>
					</div>

					{/* Cities & Pan-India Service Footer Strip (Geo & Local SEO) */}
					<div className='py-6 border-t border-slate-900 text-xs text-slate-500 leading-relaxed'>
						<p className='font-semibold text-slate-400 mb-1.5'>
							Serving Businesses Across India with Express Delivery:
						</p>
						<p>
							Bangalore, Mumbai, Delhi NCR, Hyderabad, Chennai, Kolkata, Pune, Ahmedabad, Jaipur, Surat, Lucknow, Chandigarh, Kochi, Indore, Coimbatore, Vadodara, Nagpur, Bhopal, Visakhapatnam, and 500+ cities across India.
						</p>
					</div>

					{/* Bottom Copyright */}
					<div className='pt-6 border-t border-slate-900 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-500 gap-4'>
						<p>&copy; {new Date().getFullYear()} AlphaReview (Alpha Connects). All rights reserved.</p>
						<p>Empowering 1,200+ local businesses with 5-star customer reputation.</p>
					</div>
				</Container>
			</footer>
		</Fragment>
	);
};

export default Footer;
